import dayjs from "dayjs";
import { useTranslation } from 'react-i18next';

const invoiceStyles = {
    invoiceBox: {
        width: '90%',
        margin: '0 auto',
        fontSize: '16px',
        lineHeight: '24px',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#fff',
        boxSizing: 'border-box',
        marginBottom: 10,
        border: "1px solid #eee"
    },
    logo: {
        width: '150px',
        height: 'auto',
        marginBottom: '20px'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px',
        fontSize: '12px',

    },
    heading: {
        backgroundColor: '#000',
        color: '#FFF',
    },
    headingCell: {
        padding: '10px',
        fontWeight: 'bold'
    },
    item: {},

    itemCell: {
        padding: '10px',
        verticalAlign: 'top'
    },
    total: {
        borderTop: '2px solid #eee',
        fontWeight: 'bold',
        fontSize: '12px',

    },
    headerGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px',
        marginBottom: '30px',
    },
    businessInfo: {
        textAlign: 'left'
    },
    invoiceInfo: {
        textAlign: 'left',
        padding: '15px',
        fontSize: '12px',
        color: '#555',
        lineHeight: '1.5'
    },
    shippingAddress: {
        marginBottom: '20px',
        padding: '15px',
        fontSize: '12px',
        borderRadius: '4px',
    }
};

// Add @media print styles to ensure correct printing
const PrintStyles = () => (
    <style>
        {`
            @page {
                size: A4;
                margin: 0;
            }
            @media print {
                body {
                    margin: 0;
                    padding: 0;
                }
                .invoice-container {
                    width: 310mm;
                    height: 297mm;
                    page-break-after: always;
                }
            }
        `}
    </style>
);

const Invoice = ({ order, items, address, returnData, cancelData }) => {
    const { t } = useTranslation();
    const dir = localStorage.getItem('dir');


    const getItemReturns = (itemId) => {
        return returnData?.filter(
            (ret) => Number(ret.business_return_order_item_id) === Number(itemId)
        ) || [];
    };

    const getTotalReturnedQty = (itemId) => {
        return getItemReturns(itemId)
            .filter((ret) => Number(ret.business_return_status) === 3)
            .reduce((sum, ret) => {
                return sum + Number(ret.business_return_qty || 0);
            }, 0);
    };

    const getItemCancels = (itemId) =>
        cancelData?.filter(
            (cancel) => Number(cancel.business_order_item_id) === Number(itemId)
        ) || [];

    const getTotalCancelledQty = (itemId) =>
        getItemCancels(itemId)
            .filter((cancel) => Number(cancel.business_order_cancel_status) === 1)
            .reduce(
                (sum, cancel) =>
                    sum + Number(cancel.business_order_cancel_item_qty || 0),
                0
            );

    if (!items) return <div></div>;

    return (
        <>
            <PrintStyles />
            <div className="invoice-container" style={invoiceStyles.invoiceBox} dir={dir}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: "10px",
                        width: "100%",
                        padding: "15px"
                    }}
                >
                    {/* LEFT SIDE – COMPANY INFO */}
                    <div style={{ fontSize: "12px", lineHeight: "1.5" }}>
                        <strong><b>GHAYAR AUTO SPARE PARTS TRADING L.L.C</b>
                            <br />
                            TRN: 100442212500003</strong>
                        <div>Ajman, AL Rawda 1, Algeria St, Al Meera Building, M002,
                            <br />
                            Warehouse No. 3 - Umm Dera - New Industrial Area - Emirate of Umm Al
                            Quwain</div>
                        <div>Dubai</div>
                    </div>
                    <div style={{ textAlign: "right", fontSize: "12px" }}>
                    </div>
                </div>

                <div style={{ marginBottom: "-10px" }}>
                    <h3 style={{ fontWeight: "bold", textAlign: "center", textDecoration: "underline" }}>
                        Order Details
                    </h3>
                </div>

                <div style={invoiceStyles.headerGrid}>
                    {/* Left side - Business name and shipping */}
                    <div style={invoiceStyles.businessInfo}>

                        <div style={invoiceStyles.shippingAddress}>
                            <p style={{ margin: '10px 0', lineHeight: '1.5' }}>
                                <b>Customer Name:</b> {order.business_name}<br />
                                {
                                    order.business_order_ref_client &&
                                    <>
                                        <b>Ref Client:</b> {order.business_order_ref_client}<br />
                                    </>
                                }
                                <b>Shipping Address:</b> {address.business_full_address}<br />
                                <b>City:</b> {address.business_city}<br />
                                <b>Phone:</b> {address.mobile_number_1}<br />
                                <b>Email:</b> {address.contact_email}<br />
                                <b>TRN:</b> {order.busienss_trn}
                            </p>
                        </div>
                    </div>

                    {/* Right side - Invoice details */}
                    <div style={invoiceStyles.invoiceInfo}>

                        <table style={{ marginLeft: 'auto' }}>
                            <tr>
                                <td style={{ padding: '5px 0', color: '#666' }}>Ref Order No #:</td>
                                <td style={{ padding: '5px 0 5px 15px' }}>{order.secret_order_id}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '5px 0', color: '#666' }}>Date:</td>
                                <td style={{ textAlign: "left", paddingLeft: "18px" }}>{dayjs(order.business_order_date).format("DD-MM-YYYY")}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '5px 0', color: '#666' }}>Payment Method:</td>
                                <td style={{ padding: '5px 0 5px 16px', textAlign: 'left', textTransform: 'capitalize' }}>{order.business_order_payment_method}</td>
                            </tr>
                        </table>
                    </div>
                </div>

                <table style={invoiceStyles.table} >
                    <thead>
                        <tr style={invoiceStyles.heading}>
                            <td style={invoiceStyles.headingCell}>{t("product")}</td>
                            <td style={invoiceStyles.headingCell}>Brand Name</td>
                            <td style={invoiceStyles.headingCell} align="right">{t("price")}</td>
                            <td style={invoiceStyles.headingCell} align="right">{t("quantity")}</td>
                            <td style={invoiceStyles.headingCell} align="right">{t("VAT")}</td>
                            <td style={invoiceStyles.headingCell} align="right">{t("Total")}</td>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item) => {
                            const totalReturnedQty = getTotalReturnedQty(item.item_id);
                            const totalCancelledQty = getTotalCancelledQty(item.item_id);

                            const availableCancelQty = Number(item.item_qty) - Number(totalCancelledQty) - Number(totalReturnedQty);

                            if (availableCancelQty <= 0) return null;
                            if (item?.item_status === 6) return null;
                            if (item?.item_status === 7) return null;

                            return (
                                <tr key={item.item_number} style={invoiceStyles.item}>
                                    <td style={invoiceStyles.itemCell}>
                                        {item.item_name}
                                        <br />
                                        <small>{item.item_number}</small>
                                        <br />
                                        <span className="text-dark" style={{ fontWeight: "bold" }}>{item.invoice_no && `Invoice No : ${item.invoice_no}`}</span>
                                    </td>

                                    <td style={invoiceStyles.itemCell}>
                                        {item?.item_brand}
                                    </td>

                                    <td style={invoiceStyles.itemCell} align="right">
                                        {item?.item_price}
                                    </td>
                                    <td style={invoiceStyles.itemCell} align="right">
                                        {availableCancelQty}
                                    </td>
                                    <td style={invoiceStyles.itemCell} align="right">
                                        {item.item_vat_amount}
                                    </td>
                                    <td style={invoiceStyles.itemCell} align="right">
                                        {item.item_sub_total_excl_vat}
                                    </td>
                                </tr>
                            )
                        })}

                        <tr style={invoiceStyles.total}>
                            <td colSpan="5" style={invoiceStyles.itemCell} align="right">
                                <span style={{ lineHeight: '0' }}>{order?.business_order_total_saving > 0 ? "Sub Total" : "Taxable Amount"}: </span>
                            </td>
                            <td style={invoiceStyles.itemCell} align="right">
                                {order.grand_total_excl_vat}
                            </td>
                        </tr>

                        {Number(order.business_order_total_saving) > 0 && (
                            <tr style={invoiceStyles.total}>
                                <td colSpan="5" style={invoiceStyles.itemCell} align="right">
                                    {t("Discount")}:
                                </td>
                                <td style={invoiceStyles.itemCell} align="right">
                                    {order.business_order_total_saving} AED
                                </td>
                            </tr>
                        )}

                        {
                            Number(order.business_order_total_saving) > 0 && <tr style={invoiceStyles.total}>
                                <td colSpan="5" style={invoiceStyles.itemCell} align="right">
                                    <span style={{ lineHeight: '0' }}>Taxable Amount: </span>
                                </td>
                                <td style={invoiceStyles.itemCell} align="right">
                                    {order?.business_order_sub_total - order?.business_order_total_saving} AED
                                </td>
                            </tr>
                        }


                        {order.shipping_charges > 0 && (
                            <tr style={invoiceStyles.total}>
                                <td colSpan="5" style={invoiceStyles.itemCell} align="right">
                                    {t("shipping_charges")}:
                                </td>
                                <td style={invoiceStyles.itemCell} align="right">
                                    {order.shipping_charges} AED
                                </td>
                            </tr>
                        )}

                        <tr style={{ ...invoiceStyles.total, fontSize: '12px' }}>
                            <td colSpan="5" style={invoiceStyles.itemCell} align="right">
                                <strong>{t("VAT 5%")}:</strong>
                            </td>
                            <td style={invoiceStyles.itemCell} align="right">
                                <strong>{order?.grand_total_vat_amount ? order?.grand_total_vat_amount : '00.0'}</strong>
                            </td>
                        </tr>

                        <tr style={{ ...invoiceStyles.total, fontSize: '12px' }}>
                            <td colSpan="5" style={invoiceStyles.itemCell} align="right">
                                <strong>{t("grand_total")}:</strong>
                            </td>
                            <td style={invoiceStyles.itemCell} align="right">
                                <strong>{order.grand_total_incl_vat}</strong>
                            </td>
                        </tr>


                        {/* <tr>
                            <td colSpan="6" style={{ padding: "15px" }}>
                                <div
                                    style={{
                                        marginTop: "15px",
                                        borderTop: "1px solid #ddd",
                                        paddingTop: "10px",
                                        fontSize: "12px",
                                        lineHeight: "1.7",
                                        color: "#333"
                                    }}
                                >
                                    <strong>Terms & Return Policy</strong>

                                    <ul style={{ margin: "8px 0 0 18px", padding: 0 }}>
                                        <li>Returns are accepted within <strong>3 days</strong> of the delivery date.</li>
                                        <li>Return requests submitted after 3 days from the delivery date will not be accepted.</li>
                                        <li>Products must be returned in their original condition and packaging.</li>
                                    </ul>
                                </div>
                            </td>
                        </tr> */}

                    </tbody>
                </table>
            </div >
        </>
    );
};

export default Invoice;
